export type DoubleVoteMeta = {
    voteCount: number;
    lastVoteAt: number;
    consumed: boolean;
};

export const DOUBLE_VOTE_META_KEY = "double-vote-meta";

export const DEFAULT_DOUBLE_VOTE_META: DoubleVoteMeta = {
    voteCount: 0,
    lastVoteAt: 0,
    consumed: false,
};

export const readDoubleVoteMeta = (pollId: string): DoubleVoteMeta => {
    try {
        const raw = localStorage.getItem(DOUBLE_VOTE_META_KEY);
        if (!raw) return { ...DEFAULT_DOUBLE_VOTE_META };

        const parsed = JSON.parse(raw);
        const meta = parsed?.[pollId];
        if (!meta) return { ...DEFAULT_DOUBLE_VOTE_META };

        return {
            voteCount: Number(meta.voteCount) || 0,
            lastVoteAt: Number(meta.lastVoteAt) || 0,
            consumed: Boolean(meta.consumed),
        };
    } catch {
        return { ...DEFAULT_DOUBLE_VOTE_META };
    }
};

export const persistDoubleVoteMeta = (
    pollId: string,
    meta: Partial<DoubleVoteMeta>
) => {
    try {
        const raw = localStorage.getItem(DOUBLE_VOTE_META_KEY);
        if (!raw && Object.keys(meta).length === 0) return;

        const parsed = raw ? JSON.parse(raw) : {};
        const current: DoubleVoteMeta = readDoubleVoteMeta(pollId);
        const next = {
            ...current,
            ...meta,
        };

        parsed[pollId] = next;
        localStorage.setItem(DOUBLE_VOTE_META_KEY, JSON.stringify(parsed));
    } catch {
        // ignore persistence errors
    }
};

export const clearDoubleVoteMeta = (pollId: string) => {
    try {
        const raw = localStorage.getItem(DOUBLE_VOTE_META_KEY);
        if (!raw) return;

        const parsed = JSON.parse(raw);
        if (parsed && parsed[pollId]) {
            delete parsed[pollId];
            localStorage.setItem(DOUBLE_VOTE_META_KEY, JSON.stringify(parsed));
        }
    } catch {
        // ignore cleanup errors
    }
};
